import { createContext, useContext, useState } from "react";

const ReviewsFilterContext = createContext();

// Filter options
export const SENTIMENT_OPTIONS = [
  { value: "positive", label: "Positive" },
  { value: "neutral", label: "Neutral" },
  { value: "negative", label: "Negative" },
];

export const RATING_OPTIONS = [
  { value: "5", label: "5 Stars" },
  { value: "4", label: "4 Stars" },
  { value: "3", label: "3 Stars" },
  { value: "2", label: "2 Stars" },
  { value: "1", label: "1 Star" },
];

export const REPLIED_OPTIONS = [
  { value: "true", label: "Replied" },
  { value: "false", label: "Not Replied" },
];

export const SOURCE_OPTIONS = [
  { value: "google", label: "Google" },
  { value: "tripadvisor", label: "Tripadvisor" },
];

export function ReviewsFilterProvider({ children }) {
  // Initialize with all options selected (like Dashboard pattern)
  const [sentimentFilter, setSentimentFilter] = useState(() => 
    SENTIMENT_OPTIONS.map((option) => option.value)
  );
  const [ratingFilter, setRatingFilter] = useState(() => 
    RATING_OPTIONS.map((option) => option.value)
  );
  const [repliedFilter, setRepliedFilter] = useState(() => 
    REPLIED_OPTIONS.map((option) => option.value)
  );
  const [sourceFilter, setSourceFilter] = useState(() =>
    SOURCE_OPTIONS.map((option) => option.value)
  );

  const clearAllFilters = () => {
    setSentimentFilter(SENTIMENT_OPTIONS.map((option) => option.value));
    setRatingFilter(RATING_OPTIONS.map((option) => option.value));
    setRepliedFilter(REPLIED_OPTIONS.map((option) => option.value));
    setSourceFilter(SOURCE_OPTIONS.map((option) => option.value));
  };

  // Check if any filter is NOT showing all options (i.e., user has filtered)
  const hasActiveFilters = 
    sentimentFilter.length !== SENTIMENT_OPTIONS.length ||
    ratingFilter.length !== RATING_OPTIONS.length ||
    repliedFilter.length !== REPLIED_OPTIONS.length ||
    sourceFilter.length !== SOURCE_OPTIONS.length;

  return (
    <ReviewsFilterContext.Provider
      value={{
        sentimentFilter,
        setSentimentFilter,
        ratingFilter,
        setRatingFilter,
        repliedFilter,
        setRepliedFilter,
        sourceFilter,
        setSourceFilter,
        clearAllFilters,
        hasActiveFilters,
      }}
    >
      {children}
    </ReviewsFilterContext.Provider>
  );
}

export function useReviewsFilterContext() {
  const context = useContext(ReviewsFilterContext);
  if (!context) {
    throw new Error("useReviewsFilterContext must be used within a ReviewsFilterProvider");
  }
  return context;
}
